import React, { useEffect, useState } from "react";
import Navbar from "../../component/Navbar/Navbar";
import Sidebar from "../../component/sidebar/Sidebar";

import expense1 from "../../Asset/expense 1.png";
import expense2 from "../../Asset/expense 2.png";
import expenseItem1 from "../../Asset/expenseItem 1.png";
import expenseItem2 from "../../Asset/expenseItem 2.png";
import expenselogo from "../../Asset/expense logo.png";
import cashIn1 from "../../Asset/cashIn 1.png";
import cashIn2 from "../../Asset/cashIn 2.png";
import ExpenseOut from "./ExpenseOut";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteExpense,
  getExpenseOuts,
  selectExpenses,
} from "../../redux/features/cashInOut/CashInOutSlice";
import {
  filterExpenses,
  selectFilteredExpenses,
} from "../../redux/features/filter/FilterSlice";
import ReactPaginate from "react-paginate";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
export const sidebarSections = [
  {
    name: "Expense Items",
    image1: expenseItem1,
    image2: expenseItem2,
    path: "/cashInOut/expenseItem",
  },
  {
    name: "Expenses",
    image1: expense1,
    image2: expense2,
    path: "/cashInOut/expenses",
  },
  {
    name: "CashIn",
    image1: cashIn1,
    image2: cashIn2,
    path: "/cashInOut/cashIn",
  },
];
const Expenses = () => {
  const [search, setSearch] = useState("");

  let expenses = useSelector(selectExpenses);
  const filteredExpenses = useSelector(selectFilteredExpenses);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getExpenseOuts());
  }, [dispatch]);

  const confirmDelete = (id, note) => {
    if (!id || !note) {
      toast.error("ID or note is undefined");
      return;
    }
    confirmAlert({
      title: "Delete this expense entry",
      message: `Are you sure you want to delete this expense entry: "${note}"?`,
      buttons: [
        {
          label: "Delete",
          onClick: () => removeItem(id),
        },
        {
          label: "Cancel",
        },
      ],
    });
  };

  const removeItem = async (id) => {
    await dispatch(deleteExpense(id));
    dispatch(getExpenseOuts());
  };

  const priceSymbol = process.env.REACT_APP_PRICE_SYMBOL;

  const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  const currentExpenses = filteredExpenses?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filteredExpenses?.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * itemsPerPage) % filteredExpenses?.length;

    setItemOffset(newOffset);
  };

  useEffect(() => {
    dispatch(filterExpenses({ search, expenses }));
  }, [dispatch, search, expenses]);

  return (
    <div className="flex flex-col h-screen bg-[#F1F1F1]">
      {/* Navbar */}
      <Navbar page="Expense Out" />

      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <div className="md:w-[30%] w-[35%]  bg-white shadow-md">
          <Sidebar sidebarSections={sidebarSections} />
        </div>

        {/* Main Content */}
        <div className="flex-1 p-8 relative overflow-y-auto  scrollbar-hide ">
          {/* Product List */}
          {expenses?.length > 0 ? (
            <>
              <div className="md:w-full w-[28rem]  mx-auto mb-10 ">
                <div className="flex lg:justify-end justify-start my-4 items-center ">
                  <input
                    type="search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="bg-transparent py-2 px-4 border-2 border-[#A9A9A9]  rounded-full outline-none"
                    placeholder="Search by note..."
                  />
                </div>
                <div className="lg:space-y-4 space-y-2">
                  <div
                    className={`flex items-center justify-between lg:text-[1rem] text-[.8rem]  pb-0 w-full font-bold capitalize`}
                  >
                    <div className="flex items-center  w-[60%]">
                      <span className="w-[20%]">Sr #</span>

                      <span className=" w-[80%]  ">note</span>
                    </div>

                    <div className="flex items-center w-[40%]">
                      <div className=" w-[50%]">Price</div>

                      <div className="w-[50%]">Action</div>
                    </div>
                  </div>
                  {currentExpenses?.map((expense, index) => {
                    return (
                      <div
                        key={expense?._id}
                        className={`flex items-center justify-between lg:pt-4 pt-2 pb-0 border-t-2 border-[#DEDEDE]
                        `}
                      >
                        <div className="flex items-center lg:text-[1rem] text-[.8rem]  w-[60%] ">
                          <span className="w-[20%]">{index + 1}</span>

                          <span className="font-inter-600 text-wrap capitalize w-[80%] text-[#0D868C]">
                            {expense?.description}
                          </span>
                        </div>

                        <div className="flex items-center w-[40%] lg:text-[1rem] text-[.8rem]">
                          {expense?.balance > 0 && (
                            <div className="flex gap-2 items-center w-[50%]">
                              <span
                                className={`text-[#1E1E1E]  font-inter-400 `}
                              >
                                {priceSymbol} {expense?.balance}
                              </span>
                            </div>
                          )}

                          <div className="flex items-center md:gap-3 gap-1.5 w-[50%]">
                            {/* <div className="bg-[#0D868C] text-center text-white p-1 rounded-lg cursor-pointer">
                              <MdEdit className="size-6" />
                            </div> */}
                            <ExpenseOut expense={expense} />
                            <span
                              onClick={() =>
                                confirmDelete(expense._id, expense?.description)
                              }
                              className="bg-[#f1524d] text-center text-white p-1 rounded-lg cursor-pointer"
                            >
                              <MdDelete className="lg:size-6 size-5" />
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {filteredExpenses?.length > itemsPerPage && (
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel="Next"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={2}
                    pageCount={pageCount}
                    previousLabel="Prev"
                    renderOnZeroPageCount={null}
                    containerClassName="pagination"
                    pageLinkClassName="page-num"
                    previousLinkClassName="page-num"
                    nextLinkClassName="page-num"
                    activeLinkClassName="activePage"
                  />
                )}
              </div>

              <ExpenseOut />
            </>
          ) : (
            <div className="flex items-center justify-center md:w-full w-[27rem]">
              <div className="md:w-[30rem] w-[25rem] lg:w-[38rem]  relative  lg:h-[30rem] h-[23rem] bg-[#A9A9A9] rounded-[2.4rem] text-white flex flex-col justify-center items-center ">
                <img
                  src={expenselogo}
                  className="mb-2 size-16 md:size-32"
                  alt="Logo"
                />

                <p className="text-[1rem] md:text-[1.5rem] font-inter-700 text-center">
                  You have no expense yet
                </p>
                <p className="text-[.8rem] md:text-[1rem] font-inter-400 text-center">
                  To add a expense, press the (+) button
                </p>
                <ExpenseOut />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Expenses;
